import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EConsultationRequestActions } from '../../constants/actionTypes/consultationRequest';
import { EActiveConsultationModal } from '../../types/redux/states';

export const setActiveStep = actionGenerator<
  EConsultationRequestActions.SetActiveStep,
  EActiveConsultationModal | null
>(EConsultationRequestActions.SetActiveStep);
export type TSetModalOpenAction = ReturnType<typeof setActiveStep>;

export const setServiceButtonOffset = actionGenerator<EConsultationRequestActions.SetServiceButtonOffset, number>(
  EConsultationRequestActions.SetServiceButtonOffset,
);

export type TSetServiceButtonOffset = ReturnType<typeof setServiceButtonOffset>;

export type TConsultationRequestActions = TSetModalOpenAction | TSetServiceButtonOffset;
